export default "__VITE_ASSET__DLTCgvvd__"